import { FolderIcon } from '@heroicons/react/24/outline';
import compact from 'lodash/compact';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useActiveCourse from '@/data/hook/course-progress/useActiveCourse';
import useCourseLessonsHref from '@/data/hook/course-progress/useCourseLessonsHref';
import { BreadcrumbItem } from '@/data/hook/useDynamicBreadcrumbItems';
import { ROUTES } from '@/utils/routes';

export default function useCourseLessonsBreadcrumbs(): BreadcrumbItem[] {
  const { t } = useTranslation('translation', { keyPrefix: 'breadcrumb' });
  const courseLessonsHref = useCourseLessonsHref();
  const { course, isLoading: isLoadingCourse } = useActiveCourse();

  const courseName = !isLoadingCourse ? course?.name : undefined;

  return useMemo(() => {
    const icon = <FolderIcon className="size-4" />;

    return compact([
      {
        id: 'myCourses',
        href: ROUTES.DASHBOARD.BASE,
        children: t('home'),
        icon,
      },
      courseName && {
        id: 'course',
        href: courseLessonsHref,
        children: courseName,
        icon,
      },
    ]);
  }, [t, courseName, courseLessonsHref]);
}
